import { jsx as _jsx } from "react/jsx-runtime";
import { ProjectsList } from './ProjectsList.js';
export var PromptProjectsSection = function PromptProjectsSection(param) {
    var additionalContent = param.additionalContent, errorContent = param.errorContent, fallbackContent = param.fallbackContent, projects = param.projects;
    var _projects_data;
    if (projects.isError) {
        var _ref;
        return (_ref = errorContent !== null && errorContent !== void 0 ? errorContent : fallbackContent) !== null && _ref !== void 0 ? _ref : null;
    }
    if ((_projects_data = projects.data) === null || _projects_data === void 0 ? void 0 : _projects_data.length) {
        return /*#__PURE__*/ _jsx(ProjectsList, {
            items: projects.data,
            additionalContent: additionalContent
        });
    }
    return fallbackContent !== null && fallbackContent !== void 0 ? fallbackContent : null;
};

//# sourceMappingURL=PromptProjectsSection.js.map